import { areSameOpticianDetails } from './optician-details.js';
import { areSamePrescriptionParameters } from './prescription-parameters.js';

const isSamePrescription = (server, draft)=>{
    if (server.isEmailPrescription) {
        return draft.type === 'email-prescription';
    } else if (server.isExistingCustomer) {
        return draft.type === 'existing-customer';
    } else if (server.prescriptionFile) {
        var ref, ref1;
        if (draft.type !== 'prescription-file') {
            return false;
        }
        return draft.details.prescriptionFile.storageId === server.prescriptionFile.storageId && ((ref = draft.details.pupillaryDistanceFile) === null || ref === void 0 ? void 0 : ref.storageId) === ((ref1 = server.pupillaryDistanceFile) === null || ref1 === void 0 ? void 0 : ref1.storageId);
    }
    if (draft.type !== 'new-prescription' || !server.newPrescription) {
        return false;
    }
    const { leftLens , rightLens , expiryDate , opticianDetails  } = server.newPrescription;
    return areSamePrescriptionParameters(leftLens, draft.details.leftLens) && areSamePrescriptionParameters(rightLens, draft.details.rightLens) && areSameOpticianDetails({
        expiryDate,
        opticianDetails
    }, draft.details);
};

export { isSamePrescription };
//# sourceMappingURL=prescription.js.map
